import { createAuthHooks } from "@daveyplate/better-auth-tanstack";
import { phoneNumberClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

const getBaseURL = () => {
  if (typeof window !== "undefined") {
    return `${window.location.origin}/api/auth`;
  }
  return "http://localhost:3000/api/auth";
};

export const authClient = createAuthClient({
  baseURL: getBaseURL(),
  plugins: [phoneNumberClient()],
});

export const authHooks = createAuthHooks(authClient);

export const { useSession: useBetterAuthSession, signIn, signOut } = authClient;
